/*
 * Ryan O'Dowd
 * 2022-07-22
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useMemo,
} from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const WebsiteSection = (props: WebsiteSectionProps) => {
  const styles = hooks.useStyles(getStyles);

  const bgXPos = useMemo(() => props.isWebApp ? 0 : Math.floor(Math.random() * 100), [props.isWebApp]);
  const bgYPos = useMemo(() => props.isWebApp ? 0 : Math.floor(Math.random() * 100), [props.isWebApp]);

  return (
    <View
      style={[
        styles.container,
        styles[props.isDarkBackground ? 'darkBackground' : 'lightBackground'](bgXPos, bgYPos),
        props.isWebApp && styles.webAppContainer(bgXPos, bgYPos),
        props.style,
      ]}
    >
      <View style={[styles.sectionInner, props.innerStyle]}>
        {props.title && <Text style={[styles.sectionTitle, props.isDarkBackground && styles.sectionTitleDarkBg]}>{props.title}</Text>}
        {props.children}
      </View>
    </View>
  );
};

class WebsiteSectionProps {
  children: React.ReactNode;

  title?: string | any;
  isDarkBackground?: boolean;
  isWebApp?: boolean;
  style?: any;
  innerStyle?: any;
};

export default WebsiteSection;
